import { useEffect, useState } from "react";
import { getCurrentUser } from "aws-amplify/auth";
import { getFromLocalStorage, removeFromLocalStorage, saveToLocalStorage } from "../utils/localStorageUtil";

const useAuthCheck = () => {
  const [isLoggedIn, setIsLoggedIn] = useState<boolean | null>(null);

  useEffect(() => {
    const checkUser = async () => {
      try {
        const currentUser = await getCurrentUser();

        setIsLoggedIn(true);
        saveToLocalStorage("isLoggedIn", "true");

      } catch (e: any) {
        if (e.message === "User needs to be authenticated to call this API") {
          setIsLoggedIn(false);
          removeFromLocalStorage("isLoggedIn");
        } else {
          const loggedInStatus = getFromLocalStorage("isLoggedIn");

          if (loggedInStatus === "true") {
            setIsLoggedIn(true);
          } else {
            setIsLoggedIn(false);
            removeFromLocalStorage("isLoggedIn");
          }
        }
      }
    };

    checkUser();
  }, []);

  return isLoggedIn;
};

export default useAuthCheck;
